<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{ $t('bill.split') }}</div>
    <div slot="body" style="min-height: 200px">
      <a-alert :message="$t('bill.split_tips')" class="mb-2" />
      <div class="d-flex mt-5 align-items-center">
        <span>{{$t('bill.split_chart')}}</span>
        <!--a-checkbox v-for="item in splitOpts" :key="item.key" :value="item.key" :checked="split === item.key" @change="handleCheckedChange">{{item.label}}</a-checkbox-->
        <a-radio-group v-model="split">
          <a-radio-button v-for="item in splitOpts" :key="item.key" :value="item.key">{{item.label}}</a-radio-button>
        </a-radio-group>
      </div>
    </div>
    <div slot="footer">
      <a-button v-bind="okButtonProps" @click="handleConfirm" :loading="loading" type="primary">{{ $t("dialog.ok") }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import { ANALYSIS_SPLIT_OPTS } from '@Bill/constants'
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'BillAnalysisSetSplitDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    const { split } = this.params
    return {
      split,
      splitOpts: ANALYSIS_SPLIT_OPTS,
    }
  },
  computed: {
  },
  methods: {
    handleCheckedChange (e) {
      const { value, checked } = e.target
      this.split = checked ? value : ''
    },
    async handleConfirm () {
      this.params.splitChange && this.params.splitChange(this.split)
      this.cancelDialog()
    },
  },
}
</script>
